const addStructureApi = require('services/api/thirdparty/AddStructure');
const store = require('Store');
const shouldServiceRun = require('utils/Services').shouldServiceRun;
const skuUtils = require('utils/Sku.js');

module.exports = function () {
    /* Stop service from loading if not necessary */
    if (!shouldServiceRun.addStructure()) {
        return;
    }

    let selectedSkuId = skuUtils.getProductPageData();

    let skuId = (selectedSkuId && selectedSkuId.skuId) || 
        (Sephora.productPage && Sephora.productPage.defaultSkuId);

    if (skuId) {
        addStructureApi.getSeoLinks(skuId).then(
            (resp) => {
                // require.ensure is used to package nested requires in components.chunk.js
                // rather than priority.bundle.js in order to keep priority.bundle.js lean
                require.ensure([], function(require) {
                    const UtilActions = require('utils/redux/Actions');
                    store.dispatch(UtilActions.merge('page.product', 'relatedLinks', resp.related));
                }, 'components');
            }
        ).catch({
            // Handle exception
        });
    }
};
